import { render, staticRenderFns } from "./TaskPresetField.vue?vue&type=template&id=4460185a"
import script from "./TaskPresetField.vue?vue&type=script&lang=js"
export * from "./TaskPresetField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports